<template>
  <div class="asc-plot-header-wrapper">
    <asc-plot-header
      :is-recommendation-tab="isRecommendationTab"
      :page-plot="pagePlot"
      :editable="editable"
      :plots-eyeballs-visible="plotsEyeballsVisible"
      :plots-eyeballs-readonly="plotsEyeballsReadonly"
      :on-delete-page-plot="onDeletePagePlot"
      :on-toggle-page-plot-visibility="onTogglePagePlotVisibility"
      :is-plot-updating="isPlotUpdating"
    ></asc-plot-header>
  </div>
</template>

<script>
import AscPlotHeader from '@/components/molecules/AscPlotHeader'

export default {
  name: 'AscPlotHeaderWrapper',

  components: {
    AscPlotHeader,
  },

  props: {
    pagePlot: {
      type: Object,
      default: () => {},
    },
    
    editable: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsVisible: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsReadonly: {
      type: Boolean,
      default: false,
    },
    isPlotUpdating: {
      type: Boolean,
      default: false,
    },
    onDeletePagePlot: {
      type: Function,
      default: () => {},
    },
    onTogglePagePlotVisibility: {
      type: Function,
      default: () => {},
    },
    isRecommendationTab: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-plot-header-wrapper {
  border: 1px solid $gray-400;
  margin-bottom: 20px;
}
</style>
